<template>
  <div class="diagnose-wrapper">
    <div class="enter-diagnose">
      <!-- 诊断信息 -->
      <div class="diagnose-section">
        <div class="diagnose-info-item">
          <div class="diagnose-title"><span class="required">就诊人</span></div>
          <div class="info-content">
            <div class="patient-info">{{patientInfo.username}} {{patientInfo.gender | genderFilter}}
              {{patientInfo.birthday | ageFilter}}
            </div>
            <div class="patient-info">{{(patientInfo.allergy == '否认') ? '无过敏史' : patientInfo.allergy == '不确定' ? '不确定过敏史' : patientInfo.allergy}}</div>
            <div class="patient-info-mini">身高:{{patientInfo.stature==''?'未填写':patientInfo.stature+' cm'}} </div>
            <div class="patient-info-mini">体重:{{patientInfo.weight==''?'未填写':patientInfo.weight+' kg'}} </div>
            <div class="patient-province">省份:{{patientInfo.province}} </div>
          </div>
        </div>
        <div class="diagnose-info-item">
          <div class="diagnose-title"><span class="required">转诊原因</span></div>
          <div class="info-content">
            <textarea class="info-textarea" v-model="reasonTxt" maxlength="100" placeholder="转诊原因"></textarea>
            <span class="text-limit">{{reasonTxt.length}}/100</span>
          </div>
        </div>
        <div class="diagnose-info-item">
          <div class="diagnose-title">病史</div>
          <div class="info-content">
            <textarea class="info-textarea" v-model="recordTxt" maxlength="100" placeholder="患者病情描述"></textarea>
            <span class="text-limit">{{recordTxt.length}}/100</span>
          </div>
        </div>
        <div class="form-item-vertical">
          <div class="form-type"><span class="required">上传 <em>初诊病历</em> 及 <em>处方单</em></span><span class="type-tips">最多上传9张</span></div>
          <div class="form-content">
            <div class="upload-list">
              <div class="upload-item" v-for="(item, index) in recordOssList">
                <span class="delPic" v-if="item.status == 5" @click="delRecordImage(item)">
                  <icon icon-class="close"></icon>
                </span>
                <div class="preview-box">
                  <img :src="item.url" alt="">
                  <div class="image-status" v-if="item.status != 5">上传中</div>
                  <div class="image-done" v-else>上传成功</div>
                </div>
              </div>
              <div class="upload-item uploader" v-show="wxRecordUploadCount>0">
                <div class="uploader-box" @click="wxRecordImgUpload()">
                  <icon icon-class="upload-thin"></icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="diagnose-info-item">
          <div class="diagnose-title">诊断</div>
          <div class="info-content">
            <textarea class="info-textarea" v-model="reportTxt" maxlength="100" placeholder="诊断描述"></textarea>
            <span class="text-limit">{{reportTxt.length}}/100</span>
          </div>
        </div>
        <div class="form-item-vertical">
          <div class="form-type"><span>上传现有辅助检查结果、报告</span><span class="type-tips">最多上传9张</span></div>
          <div class="form-content">
            <div class="upload-list">
              <div class="upload-item" v-for="(item, index) in reportOssList">
                <span class="delPic" v-if="item.status == 5" @click="delReportImage(item)">
                  <icon icon-class="close"></icon>
                </span>
                <div class="preview-box">
                  <img :src="item.url" alt="">
                  <div class="image-status" v-if="item.status != 5">上传中</div>
                  <div class="image-done" v-else>上传成功</div>
                </div>
              </div>
              <div class="upload-item uploader" v-show="wxReportUploadCount>0">
                <div class="uploader-box" @click="wxReportImgUpload()">
                  <icon icon-class="upload-thin"></icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-item-vertical" v-if="!docSelect">
          <div class="form-type"><span class="required">推荐转诊医生</span></div>
          <div class="form-content">
            <div class="upload-list">
              <div class="upload-item uploader" @click="recommendDoc()">
                <div class="plus-box">
                  <icon icon-class="invite-doctor"></icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-item-vertical" v-else>
          <div class="form-type"><span class="required">已选择转诊医生</span></div>
          <div class="doc-box" @click="recommendDoc()">
            <div class="doc-info">
              <div class="info">
                <div class="avatar"><img :src="docEntry.avatar" alt=""></div>
                <div class="info-text">
                  <div class="name">{{docEntry.username}}<span>{{docEntry.title | jobTitleFilter}}</span></div>
                  <div class="title">{{docEntry.work_unit}}</div>
                  <div class="department"><span>{{docEntry.p_dep_title}}</span>|<span>{{docEntry.dep_title}}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="diagnose-bottom-control">
        <!--
        <button class="botton-button save" @click="saveTemplate" :disabled="savedTemplate">保存为处方模板</button>
        -->
        <button class="botton-button send" @click="sendScriptTip">提交</button>
      </div>
      <!-- 弹窗 -->
      <!-- 选择开方剂型弹窗 -->
      <van-popup v-model="chooseDoctor" position="bottom">
        <div class="popup-wrapper">
          <div class="popup-header">
            选择转诊医生
            <span class="close-popup" @click="chooseDoctor = false">取消</span>
          </div>
          <div class="formulation-wrapper">
            <div class="doc-list" v-if="referDocList.length > 0">
              <div class="doc-item" :key="index" v-for="(item, index) in referDocList">
                <div class="doc-box" @click="selectDoc(item)">
                  <div class="doc-info">
                    <div class="info">
                      <div class="avatar"><img :src="item.avatar" alt=""></div>
                      <div class="info-text">
                        <div class="name">{{item.username}}<span>{{item.title | jobTitleFilter}}</span></div>
                        <div class="title">{{item.work_unit}}</div>
                        <div class="department"><span>{{item.p_dep_title}}</span>|<span>{{item.dep_title}}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
      <!-- 发送给患者弹窗 -->
      <x-dialog v-if="sendScriptShow" title="发送会诊单" @close="sendScriptShow = false">
        <div class="dialog-content">
          <div class="text">是否将处方发送给患者</div>
          <div class="control">
            <button class="cancel" @click="sendScriptShow = false">再修改一下</button>
            <button class="confirm" @click="sendScript">确定</button>
          </div>
        </div>
      </x-dialog>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .diagnose-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    width: 100%;
    padding: 12px 8px 0;

    .doc-box{
      margin-left: 0px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      border-bottom: 1px solid #EEE;
      padding: 14px 16px 14px 0;
      width: 100%;
      .avatar{
        width: 44px;
        height: 44px;
        overflow: hidden;
        border-radius: 50%;
        background: #F9F9F9;
        flex-shrink: 0;
        img{
          width: 100%;
        }
      }
      .doc-info{
        flex: 1;
        padding: 4px 0 0 12px;
      .info{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
      .avatar{
        width: 56px;
        height: 56px;
        overflow: hidden;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 100%;
        }
      }
      .info-text{
        width: 96%;
        margin-left: 8px;
        margin-top: 2px;
        .name{
          font-size: 15px;
          line-height: 18px;
          color: @black;
          padding-left: 8px;
          max-width: 90%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: bold;
          span{
            padding-left: 10px;
            color: #999;
            font-size: 14px;
          }
        }
        .title{
          margin-top: 6px;
          color: #999;
          font-size: 14px;
          font-weight: normal;
          padding-left: 8px;
        }
        .department{
          margin-top: 8px;
          height: 24px;
          font-size: 14px;
          line-height: 24px;
          color: rgba(0, 132, 138, 0.2);
          display: inline-flex;
          align-items: center;
          .xile-alpha(0.06);
          span{
            color: @xile;
            margin: 0 8px;
          }
        }
      }
    }
        .info-province{
          margin-top: 6px;
          font-size: 12px;
          line-height: 14px;
          color: #666666;
        }

      }
    }
    .formulation-wrapper{
      padding: 5px 5px 0;

      min-height:500px;
      max-height:90%;;
      .doc-list{
        padding-top: 47px;
        width: 100%;
        .doc-item{
          width: 100%;
          transition: all .1s;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          &:active{
            background: #F9F9F9;
          }

        }
      }
    }
    .form-item-vertical{
      margin-bottom: 40px;
    .form-type{
     font-size: 16px;
     color: #666;
     font-weight: bold;
     .required{
       position: relative;
       em{
         color: @xile;
       }
       &::after{
         content: '*';
         position: absolute;
         left: 100%;
         top: 0;
         margin-left: 2px;
         font-size: 16px;
         color: @error;
       }
     }
     .tips{
       margin-top: 6px;
       font-size: 12px;
       color: @xile;
     }
     .type-tips{
       margin-left: 15px;
       font-size: 14px;
       color: #999;
     }
   }
   .form-content{
     position: relative;
     margin-top: 12px;
     .upload-list{
       display: flex;
       justify-content: flex-start;
       align-items: flex-start;
       flex-wrap: wrap;
       margin-bottom: -16px;
       .upload-item{
         position: relative;
         width: 96px;
         height: 96px;
         margin: 0 16px 16px 0;
         &:nth-child(3n){
           margin-right: 0
         }
         .preview-box{
           position: relative;
           width: 100%;
           height: 100%;
           overflow: hidden;
           display: flex;
           justify-content: center;
           align-items: center;
           overflow: hidden;
           border-radius: 4px;
           background: #000;
           img{
             width: 100%;
           }
           .image-status{
             position: absolute;
             left: 0;
             bottom: 0;
             width: 100%;
             height: 20px;
             line-height: 20px;
             background: rgba(0, 0, 0, .5);
             color: #FFF;
             text-align: center;
             font-size: 12px;
           }
           .image-done{
             position: absolute;
             left: 0;
             bottom: 0;
             width: 100%;
             height: 20px;
             line-height: 20px;
              background: @xile;;
             color: #FFF;
             text-align: center;
             font-size: 12px;
           }
         }
         .delPic{
           position: absolute;
           top: -8px;
           right: -8px;
           width: 20px;
           height: 20px;
           display: flex;
           justify-content: center;
           align-items: center;
           border: 1px solid #DDD;
           border-radius: 50%;
           background: #FFF;
           z-index: 20;
           svg{
             font-size: 12px;
             color: #999;
           }
         }
         &.uploader{
           .uploader-box{
             width: 100%;
             height: 100%;
             border: 1px dashed #CCC;
             background: #F3F3F3;
             display: flex;
             justify-content: center;
             align-items: center;
             border-radius: 4px;
             svg{
               font-size: 28px;
               color: #CCC;
             }
           }
           .plus-box{
             width: 70%;
             height: 70%;
             border: 1px dashed #CCC;
             background: #F3F3F3;
             display: flex;
             justify-content: center;
             align-items: center;
             border-radius: 4px;
             svg{
               font-size: 38px;
               color: #CCC;
             }
           }
         }
       }
     }
   }
 }
    .diagnose-section{
      margin-bottom: 12px;
      background: #FFF;
      border-radius: 6px;
      padding: 24px 16px 1px;
      .diagnose-title{
        font-size: 16px;
        line-height: 16px;
        color: #666;
        font-weight: bold;
        span{
          position: relative;
          &.required::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            font-size: 16px;
            line-height: 16px;
            color: @error;
            margin-left: 1px;
          }
        }
      }
      .selector-item{
        height: 32px;
        padding: 0 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #E0E6E6;
        background: #F7F7F7;
        color: #999;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;
        transition: all .1s;
        &:first-child{
        margin-right: 16px;
        }
        &.selected{
          border-color: @xile;
          background: @xile;
          color: #FFF;
        }
      }
      .info-textarea{
        width: 100%;
        height: 96px;
        background: #F7F7F7;
        border-radius: 4px;
        padding: 12px;
        font-size: 14px;
        line-height: 20px;
        color: @black;
        resize: none;
      }
      .text-limit{
        position: absolute;
        right: 8px;
        bottom: 8px;
        font-size: 12px;
        line-height: 12px;
        color: #999;
      }
      .diagnose-info-item{
        margin-bottom: 32px;
        .photo-pres-box{
          margin-top: 10px;
          width: 150px;
          max-height: 100px;
          overflow: hidden;
          border:dashed 1px #ddd;
          img{
            display: block;
            margin:5px auto;
            width: 98%;
          }
        }
        .info-content{
          margin-top: 12px;
          position: relative;
          .disease-judge{
            width: 100%;
            height: 30px;
            background: #F7F7F7;
            border-radius: 4px;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            color: @black;
          }
          .patient-info{
            font-size: 18px;
            line-height: 20px;
            color: @black;
            font-weight: bold;
            margin-top: 10px;
          }
          .patient-info-mini{
            padding-top:10px;
            font-size: 15px;
            line-height: 17px;
            color: #474747;
            font-weight:600;
          }
          .patient-province{
            padding-top:10px;
            font-size: 15px;
            line-height: 17px;
            color: #474747;
            font-weight: 0;
            font-weight:600;
          }
        }
      }

    }
    .diagnose-bottom-control{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 0;

      .botton-button{
        @button-base();
        height: 40px;
        &.save{
          width: 128px;
          @button-border();
          .xile-alpha(0.05);
          &:disabled{
            opacity: .6;
          }
        }
        &.send{
          margin-left: 15px;
          flex: 1;
        }
      }
    }
    .dialog-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .warning-text{
        width: 80%;
        font-size: 15px;
        line-height: 21px;
        font-weight: bold;
        color: @black;
      }
      .text{
        font-size: 16px;
        line-height: 16px;
        color: @black;
        font-weight: bold;
        span{
          margin-left: 4px;
          color: @error;
        }
      }
      .control{
        margin-top: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    .save-content{
      padding: 29px 0 47px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .save-input{
        .save-title{
          font-size: 14px;
          line-height: 14px;
          color: #666;
          font-weight: bold;
        }
        .save-text{
          position: relative;
          width: 287px;
          height: 48px;
          background: #F7F7F7;
          border-radius: 4px;
          margin-top: 12px;
          overflow: hidden;
          .save-typer{
            width: 100%;
            padding: 17px 12px;
            font-size: 14px;
            line-height: 14px;
            color: @black;
            background: #F7F7F7;
          }
          .text-limit{
            position: absolute;
            bottom: 8px;
            right: 8px;
            font-size: 12px;
            line-height: 12px;
            color: #999;
          }
        }
      }
      .save-control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }

  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  import stepper from '@/components/Common/stepper'
  import numberInput from '@/components/Common/numberInput'
  export default {
    data() {
      return {

        // 处方剂型
        formulationType: parseInt(this.$route.query.type),

        // 患者信息
        patientInfo: {},
        //转诊原因
        reasonTxt: '',
        // 主诉
        recordTxt: '',
        // 诊断
        reportTxt: '',

        // 发送处方给患者
        sendScriptShow: false,

        // 上传病历照片实例
        recordUploader: null,
        recordImgList: [],
        recordOssList: [],
        wxRecordUploadLocalArray: [],
        wxRecordUploadServerArray: [],
        wxRecordUploadCount: 9,
        wxRecordUploadStatus: false,
        // 上传现有辅助检查结果、报告实例
        reportUploader: null,
        reportImgList: [],
        reportOssList: [],
        wxReportUploadLocalArray: [],
        wxReportUploadServerArray: [],
        wxReportUploadCount: 9,
        wxReportUploadStatus: false,

        chooseDoctor: false,
        saving: false,

        referDocList: [],
        docEntry: {},
        recom_docid: 0,
        docSelect: false
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      xDialog,
      stepper,
      numberInput
    },
    created() {
      let _this = this;
      //加载jssdk
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseImage', 'uploadImage']
          });

        }

      })

      // 获取患者基本信息以及处方基本信息
      this.$root.post('/getInfo', {
        doc_id: this.userInfo.user_id,
        pat_id: this.$route.query.pat_id
      }).then(data => {
        console.log(data)
        this.patientInfo = data || {};

      })
      this.getReferDocList();
    },
    methods: {
      getReferDocList() {
        // 获取患者基本信息以及处方基本信息
        this.$root.post('/getReferDocList', {
          doc_id: this.userInfo.user_id
        }).then(data => {
          console.log(data)
          this.referDocList = data || {};

        })
      },
      selectDoc(item) {

        console.log(item)
        this.docEntry = item;
        this.recom_docid = item.user_id;
        this.docSelect = true;
        this.chooseDoctor = false;
      },
      wxReportSyncUpload() {
        let _this = this;
        if (_this.wxReportUploadLocalArray.length == 0) {
          _this.wxReportUploadStatus = false;
        } else {
          var entry = _this.wxReportUploadLocalArray.shift();
          _this.wxReportUploadCount -= 1;
          wx.uploadImage({
            localId: entry.localid,
            isShowProgressTips: 0,
            success: function(res) {
              var serverId = res.serverId
              _this.wxReportUploadServerArray.push(serverId);

              _this.reportOssList.forEach(item => {
                if (item.localid == entry.localid) {
                  item.serverid = serverId
                }
              });
              console.log("上传第" + entry.localid + '张')

              _this.$root.post('/getWxImg', {
                id: serverId,
                oss_dir: 'patient',
                filename: serverId,
                type: 1
              }).then(data => {
                console.log("返回服务端数据")
                console.log(data)
                if (data.status == 1) {
                  _this.reportOssList.forEach(item => {
                    if (item.serverid == serverId) {
                      item.url = data.url;
                      item.status = 5;
                    }
                  });

                } else {
                  _this.$notify('发送图片失败');
                }
              })
              _this.wxReportSyncUpload();
            },
            fail(err) {
              console.log('error');
              _this.$toast.clear();
              _this.$notify(`上传图片报错${JSON.stringify(err)}`);
            }
          });
        }

      },
      wxReportImgUpload() {
        let _this = this;
        wx.chooseImage({
          count: _this.wxReportUploadCount, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            _this.wxReportUploadStatus = true;
            res.localIds.forEach(item => {
              var entry = {
                status: 1,
                localid: item,
                url: item,
                serverid: ''
              };
              _this.wxReportUploadLocalArray.push(entry);
              _this.reportOssList.push(entry);
            });

            _this.wxReportSyncUpload();

          }
        });

      },
      delReportImage(item) {
        let _this = this;
        let index = _this.reportOssList.indexOf(item)
        _this.reportOssList.splice(index, 1);
        _this.wxReportUploadCount += 1;
      },
      wxRecordSyncUpload() {
        let _this = this;
        if (_this.wxRecordUploadLocalArray.length == 0) {
          _this.wxRecordUploadStatus = false;
        } else {
          var entry = _this.wxRecordUploadLocalArray.shift();
          _this.wxRecordUploadCount -= 1;
          wx.uploadImage({
            localId: entry.localid,
            isShowProgressTips: 0,
            success: function(res) {
              var serverId = res.serverId
              _this.wxRecordUploadServerArray.push(serverId);

              _this.recordOssList.forEach(item => {
                if (item.localid == entry.localid) {
                  item.serverid = serverId
                }
              });
              console.log("上传第" + entry.localid + '张')

              _this.$root.post('/getWxImg', {
                id: serverId,
                oss_dir: 'patient',
                filename: serverId,
                type: 1
              }).then(data => {
                console.log("返回服务端数据")
                console.log(data)
                if (data.status == 1) {
                  _this.recordOssList.forEach(item => {
                    if (item.serverid == serverId) {
                      item.url = data.url;
                      item.status = 5;
                    }
                  });

                } else {
                  _this.$notify('发送图片失败');
                }
              })


              _this.wxRecordSyncUpload();
            },
            fail(err) {
              console.log('error');
              _this.$toast.clear();
              _this.$notify(`上传图片报错${JSON.stringify(err)}`);
            }
          });
        }

      },
      wxRecordImgUpload() {
        let _this = this;
        wx.chooseImage({
          count: _this.wxRecordUploadCount, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            _this.wxRecordUploadStatus = true;
            res.localIds.forEach(item => {
              var entry = {
                status: 1,
                localid: item,
                url: item,
                serverid: ''
              };
              _this.wxRecordUploadLocalArray.push(entry);
              _this.recordOssList.push(entry);
            });

            _this.wxRecordSyncUpload();

          }
        });

      },
      delRecordImage(item) {
        let _this = this;
        let index = _this.recordOssList.indexOf(item)
        _this.recordOssList.splice(index, 1);
        _this.wxRecordUploadCount += 1;
      },
      recommendDoc() {
        this.chooseDoctor = true;
      },
      // 发送处方给患者弹窗
      sendScriptTip() {

        if (!this.reasonTxt) {
          this.$notify('请填写转诊原因');
          return;
        }

        if (this.recordOssList.length == 0) {
          this.$notify('请上传患者病历');
          return;
        }
        if (this.recordOssList.length == 0) {
          this.$notify('请上传诊断结果单');
          return;
        }
        if (this.wxRecordUploadStatus) {
          this.$notify('请等待所有图片上传完成');
          return;
        }
        if (this.wxReportUploadStatus) {
          this.$notify('请等待所有图片上传完成');
          return;
        }
        if (!this.recom_docid) {
          this.$notify('请选择转诊医生');
          return;
        }

        this.sendScriptShow = true;
      },
      // 发送处方给患者
      sendScript() {
        let _this = this;
        this.saving = true;
        var record_img = [];
        if (this.recordOssList.length > 0) {
          this.recordOssList.forEach(item => {
            if (item.status == 5) {
              record_img.push(item.url);
            }
          });
        }
        var result_img = [];
        if (this.reportOssList.length > 0) {
          this.reportOssList.forEach(item => {
            if (item.status == 5) {
              result_img.push(item.url);
            }

          });
        }
        const postData = {
          pat_id: this.$route.query.pat_id,
          referral_reason: this.reasonTxt,
          ori_docid: this.userInfo.user_id,
          record_img: record_img,
          report_img: result_img,
          record_txt: this.recordTxt,
          report_txt: this.reportTxt,
          recom_docid: this.recom_docid,
          refer_docid: 0
        }
        this.sendScriptShow = false;

        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '提交中'
        });

        this.$root.post('/CreateRefer', postData).then(data => {
          this.$toast.clear();
          if (data.status == 1) {
            console.log(data)

            // 发送自定义的处方卡片
            let conversationType = RongIMLib.ConversationType.PRIVATE;
            let targetId = this.$route.query.pat_id.toString();

            let msg = new RongIMClient.RegisterMessage.ReferMessage({
              username: this.patientInfo.username,
              reason: this.reasonTxt,
              create_time: data.create_time,
              birthday: this.patientInfo.birthday,
              gender: this.patientInfo.gender,
              id: data.refer_id,
            })
            RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
              onSuccess: function(message) {
                _this.$notify({
                  background: '#00848A',
                  message: '转诊信息发送成功'
                });
                _this.$router.go(-1);
              },
              onError: function(errorCode) {
                console.log('发送自定义消息失败', errorCode);
              }
            })

          } else {
            this.$notify(data.msg);
          }
        })

      },

    },


    filters: {
      floatTypeFilter(type) {
        if (type == 'plus') {
          return '+';
        } else {
          return '-';
        }
      },
      formulationTypeFilter(type) {
        switch (type) {
          case 1:
            return '中药饮片';
            break;
          case 2:
            return '配方颗粒';
            break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Diagnose/diagnoseGroup.vue